// Angular
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

// Local

export function addressFieldRequiredValidator(
  formGroup: FormGroup,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const addressType = formGroup.get('addressType')?.value?.value;
    const address1 = formGroup.get('address1')?.value;
    const city = formGroup.get('city')?.value;
    const state = formGroup.get('state')?.value;
    const zip = formGroup.get('zip')?.value;

    const fields = [addressType, address1, city, state, zip];
    const isAnyFieldFilled = fields.some(field => !!field);

    // If any field is filled, ensure all fields are filled
    if (isAnyFieldFilled) {
      return Validators.required(control);
    }
    return null;
  };
}
